<script>
import router from "../../router/routes";
import NavBar from "@/components/nav-bar-store";
import SideBar from "@/components/side-bar-store";
import Footer from "@/components/footer-store";
import { api } from "@/state/services";

export default {
  components: { NavBar, SideBar, Footer },
  beforeCreate: function () {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false,

      cart: {
        items: {
          total: 0,
          list: null
        },
        points: {
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '',
          value: '0.00',
        },
        total: '0.00'
      }
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    getCart() {
      if (!localStorage.cart) {
        api
          .get('store/cart')
          .then(response => {
            if (response.data.status == 'success') {
              this.cart.items.loading = false
              this.setStorage(response.data)
            }
          })
          .catch(error => {
            this.cart.errored = error
          })
          .finally(() => {
            this.cart.items.loading = false
          })
      } else {
        this.cart = JSON.parse(localStorage.cart)
        this.cart.items.loading = false
      }
    },
    setStorage(data) {
      this.cart.items.total = data.items.total
      this.cart.items.list = data.items.list
      this.cart.points = data.points
      this.cart.subtotal = data.subtotal
      this.cart.sale = data.sale
      this.cart.shipping = data.shipping
      this.cart.total = data.total

      localStorage.cart = JSON.stringify(this.cart)
    },
  },
  mounted() {
    this.getCart()
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" :items="cart.items.total" />
    <SideBar :isCondensed="isMenuCondensed" :cart="cart" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer :cart="cart" />
    </div>
  </div>
</template>